import { useState, useEffect } from 'react';

export const InlineEditText = ({
  value,
  onSave,
  placeholder = 'Click to edit',
  asBlock = false, // NEW: switch between span (inline) or div (block)
  showIcon = false,
  inputClassName,
}: {
  value: string;
  onSave: (val: string) => void;
  placeholder?: string;
  asBlock?: boolean;
  showIcon?: boolean;
  inputClassName?: string;
}) => {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value); // keep in sync with external changes
  }, [value]);

  const handleSave = () => {
    setEditing(false);
    if (text.trim() !== value) onSave(text.trim());
  };

  const handleCancel = () => {
    setEditing(false);
    setText(value); // reset back to original
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  const Wrapper = asBlock ? 'div' : 'span';

  const wrapperCss = asBlock
    ? {
        display: 'block',
        width: '100%',
        height: '100%',
        position: 'absolute' as const,
      }
    : {};

  return editing ? (
    <input
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={handleSave}
      onKeyDown={handleKeyDown}
      autoFocus
      className={inputClassName ?? ''}
      style={{ width: asBlock ? '100%' : '' }} // make input fill the cell
    />
  ) : (
    <Wrapper
      onClick={() => setEditing(true)}
      className="mx-2"
      style={{
        cursor: 'pointer',
        color: !value ? '#888' : 'inherit',
        ...wrapperCss,
      }}
    >
      {value || placeholder}{' '}
      {showIcon && <i className="bi bi-pencil-square"></i>}
    </Wrapper>
  );
};
